import { Box, Loader, Select, TextInput } from '@mantine/core';
import { ReactElement } from 'react';
import { useInsurerList } from '@/hooks/useInsurerList';

/**
 * The insurance composer's first row (BAR-3080): Insurer, a searchable select over the one
 * insurer list, then Member ID and Group ID. Spans the grid, as the prototype's `.trio`.
 */
export function InsuranceCoverageFields({
  insurer,
  onInsurerChange,
  memberId,
  onMemberIdChange,
  groupNumber,
  onGroupNumberChange,
  disabled,
}: {
  /** The insurer Organization's reference string. */
  insurer: string | null;
  onInsurerChange: (insurer: string | null) => void;
  memberId: string;
  onMemberIdChange: (memberId: string) => void;
  groupNumber: string;
  onGroupNumberChange: (groupNumber: string) => void;
  disabled?: boolean;
}): ReactElement {
  const { options, loading } = useInsurerList({ enabled: !disabled });

  return (
    <Box
      style={{
        gridColumn: '1 / -1',
        display: 'grid',
        gridTemplateColumns: '2fr 1fr 1fr',
        gap: 'var(--mantine-spacing-sm) var(--mantine-spacing-md)',
      }}
    >
      <Select
        label="Insurer"
        placeholder="Select an insurer"
        data={options.map((option) => ({ value: option.reference, label: option.name }))}
        value={insurer}
        onChange={onInsurerChange}
        searchable
        rightSection={loading ? <Loader size={12} /> : undefined}
        disabled={disabled}
      />
      <TextInput
        label="Member ID"
        value={memberId}
        onChange={(event) => onMemberIdChange(event.currentTarget.value)}
        autoComplete="off"
        disabled={disabled}
      />
      <TextInput
        label="Group ID"
        value={groupNumber}
        onChange={(event) => onGroupNumberChange(event.currentTarget.value)}
        autoComplete="off"
        disabled={disabled}
      />
    </Box>
  );
}
